import React, { useState, useEffect } from 'react';
import CariSopirdo from './CariSopirdo';

function InputTs({ onCancel, onSave, editMode, pasang, title }) {
  const [tglTransaksi, setTglTransaksi] = useState('');
  const [noTransaksi, setNoTransaksi] = useState('');
  const [sopir, setSopir] = useState('');
  const [nodo, setNodo] = useState('');
  const [kdkendaraan, setKdkendaraan] = useState('');
  const [nopol, setNopol] = useState('');
  const [kotaasal, setKotaasal] = useState('');
  const [kotatujuan, setKotatujuan] = useState('');  
  const [status, setStatus] = useState('');
  const [norek, setNorek] = useState('');
  const [detailBarang, setDetailBarang] = useState([]);
  const [idUser, setIdUser] = useState('');
  const [showSopirdoLookup, setShowSopirdoLookup] = useState(false);
  const schema = localStorage.getItem('schema');

  useEffect(() => {
    const today = new Date();
    const formattedToday = today.toISOString().split('T')[0];  

    if (editMode && pasang) {
      const { master, details } = pasang;
      setTglTransaksi(formatDateForInput(master.TGL_TRANSAKSI));
      setNoTransaksi(master.NO_TRANSAKSI || '');
      setSopir(master.SOPIR || '');
      setNodo(master.NO_DO || '');
      setKdkendaraan(master.KD_KENDARAAN || '');
      setNopol(master.NOPOL || '');
      setKotaasal(master.KOTA_ASAL || '');
      setKotatujuan(master.KOTA_TUJUAN || '');
      setStatus(master.STATUS || '');
      setNorek(master.NOREK || '');

      if (details && Array.isArray(details)) {
        const withDisplay = details.map((item) => ({
          ...item,
          displayTotal: formatNumber(item.TOTAL)
        }));
        setDetailBarang(withDisplay);
      } else {
        setDetailBarang([]);
      }
    } else if (pasang?.isNew) {
      setNoTransaksi(0);
      setTglTransaksi(formattedToday);
    }

    const idUser = localStorage.getItem('id_user') || '';
    setIdUser(idUser);
  }, [editMode, pasang]);


  const formatNumber = (value) => {
    if (value === '' || value === null) return '';
    return parseFloat(value).toLocaleString('id-ID');
  };

  const unformatNumber = (formattedValue) => {
    return formattedValue.replace(/\./g, '');
  };

  const handleQtyChange = (index, value) => {
    const updated = [...detailBarang];
    updated[index].displayTotal = value;
    setDetailBarang(updated);
  };

  const handleBlur = (index) => {
    const updated = [...detailBarang];
    const rawValue = unformatNumber(updated[index].displayTotal);
    updated[index].TOTAL = rawValue;
    updated[index].displayTotal = formatNumber(rawValue);
    setDetailBarang(updated);
  };

  const formatDateForInput = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
  };


const handleValidasi = async () => {
  const id = noTransaksi || '0';

  try {
    const formData = new URLSearchParams();
    formData.append('caller', 'ts');
    formData.append('id', id);
    formData.append('schema', schema);
    formData.append('id_user', idUser);
    formData.append('tgl_transaksi', tglTransaksi);
    formData.append('no_do', nodo);
    formData.append('sopir', sopir);
    formData.append('kd_kendaraan', kdkendaraan);
    formData.append('nopol', nopol);
    formData.append('kota_asal', kotaasal);
    formData.append('kota_tujuan', kotatujuan);
    formData.append('detail', JSON.stringify(detailBarang));

    const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/ts.php`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: formData.toString(),
    });

    const result = await response.json();

    if (result.status !== 'success') {
      alert(`Gagal validasi master: ${result.message}`);
      return;
    }

    onSave();
  } catch (err) {
    console.error('Error saat validasi TS:', err);
    alert('Terjadi kesalahan saat menyimpan TS dan detail.');
  }
};


  const handleSelectSopir = (selectedSopir) => {
  setSopir(selectedSopir.SOPIR); 
  setNodo(selectedSopir.NO_TRANSAKSI);    
  setKdkendaraan(selectedSopir.KD_KENDARAAN);
  setNopol(selectedSopir.NOPOL);  
  setKotaasal(selectedSopir.KOTA_ASAL);
  setKotatujuan(selectedSopir.KOTA_TUJUAN);
  setNopol(selectedSopir.NOPOL);
  setNorek(selectedSopir.NOREK);
  setShowSopirdoLookup(false);
  };

  const handleTambahDetail = async () => {
  try {
    if (!nodo) {
      alert("No DO kosong.");
      return;
    }

    const encodedNoDo = encodeURIComponent(nodo);
    const url = `${process.env.REACT_APP_API_BASE_URL}/utama.php?caller=pilih_do&schema=${schema}&no_transaksi=${encodedNoDo}`;
    const response = await fetch(url);
    const data = await response.json();

    if (Array.isArray(data)) {
      const tambahan = data.map((item, index) => ({
        NOMOR: detailBarang.length + index + 1,
        NO_DO: item.NO_DO,
        NO_MG: item.NO_MG,
        JNS_GAJI: item.JNS_GAJI,
        KETERANGAN: item.KETERANGAN || '',
        TOTAL: item.SISA,
        displayTotal: formatNumber(item.SISA),
      }));

      setDetailBarang([...detailBarang, ...tambahan]);
    } else {
      alert("Data DO tidak valid.");
    }
  } catch (err) {
    console.error("Gagal ambil data DO:", err);
    alert("Terjadi kesalahan saat mengambil detail DO.");
  }
};

const handleHapusDetail = (index) => {
  const updated = detailBarang.filter((_, i) => i !== index);
  const reindexed = updated.map((item, idx) => ({
    ...item,
    NOMOR: idx + 1,
  }));
  setDetailBarang(reindexed);
};


  return (
    <div style={{ padding: '20px', backgroundColor: '#fff', borderRadius: '10px', boxShadow: '0 0 10px rgba(0,0,0,0.1)' }}>
      <h2 style={{ marginBottom: '20px', color: '#4A4A4A' }}>{title}</h2>

      {showSopirdoLookup && (
        <CariSopirdo
          sopir={sopir}
          onSelect={handleSelectSopir}
          onCancel={() => setShowSopirdoLookup(false)}
        />
      )}    
      
{!showSopirdoLookup && (
  <>

      <div>
        <label><strong>No Transaksi</strong></label>
        <input type="text" readOnly value={noTransaksi}
          style={{ width: '100%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

      <div>
        <label><strong>Tanggal</strong></label>
        <input type="date" value={tglTransaksi} onChange={(e) => setTglTransaksi(e.target.value)}
          style={{ width: '100%', padding: '8px', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

 
      <div style={{ marginBottom: '10px' }}>
        <label>Sopir</label>
        <div style={{ display: 'flex', gap: '5px' }}>
          <input type="text" value={sopir} readOnly style={{ flex: 1, padding: '5px', backgroundColor: '#E6E6E6'  } } />
          <button
            onClick={() => setShowSopirdoLookup(true)}
            disabled={status === '9' || status === '5' || status === '6'}
            style={{marginTop: '10px', marginBottom: '10px', padding: '5px 10px', backgroundColor: '#00A2E8', color: 'white', border: 'none', borderRadius: '5px', cursor: 'pointer', }}
          >
            Cari
          </button>
        </div>
      </div>   

      <div>
        <label><strong>Norek</strong></label>
        <input type="text" readOnly value={norek}
          style={{ width: '95%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

      <div>
        <label><strong>No Do</strong></label>
        <input type="text" readOnly value={nodo}
          style={{ width: '95%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', marginBottom: 10 }}
        />
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <div style={{ flex: 1 }}>
          <label><strong>Kode Kendaraan</strong></label>
          <input type="text" readOnly value={kdkendaraan} style={{ width: '90%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>

        <div style={{ flex: 1 }}>
          <label><strong>Nopol</strong></label>
          <input type="text" readOnly value={nopol} style={{ width: '90%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
      </div>


      <div style={{ display: 'flex', gap: '10px', marginBottom: '10px' }}>
        <div style={{ flex: 1 }}>
          <label><strong>Kota Asal</strong></label>
          <input type="text" readOnly value={kotaasal} style={{ width: '90%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>

        <div style={{ flex: 1 }}>
          <label><strong>Kota Tujuan</strong></label>
          <input type="text" readOnly value={kotatujuan} style={{ width: '90%', padding: '8px', backgroundColor: '#E6E6E6', borderRadius: '5px', border: '1px solid #ccc' }} />
        </div>
      </div>
    
    <button
      onClick={handleTambahDetail}
      disabled={!nodo || status === '5' || status === '9' || detailBarang.length > 0}
      style={{
        padding: '8px 15px',
        backgroundColor: detailBarang.length > 0 ? '#ccc' : '#FFA000',
        color: 'white',
        border: 'none',
        borderRadius: '5px',
        cursor: detailBarang.length > 0 ? 'not-allowed' : 'pointer',
      }}
    >
      Tambah
    </button>

      {detailBarang.length > 0 ? (
        <div style={{ overflowX: 'auto' }}>
          <table style={{ width: '100%', borderCollapse: 'collapse', marginBottom: '20px' }}>
          <thead style={{ backgroundColor: '#f0f0f0' }}>
            <tr>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '10px' }}>No.</th>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '20%' }}>No. DO</th>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '20%' }}>Jns Gaji</th>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '30%' }}>Keterangan</th>
              <th style={{ border: '1px solid #ddd', padding: '10px', width: '20%' }}>Total</th>
              <th style={{ border: '1px solid #ddd', padding: '10px' }}>Aksi</th>
            </tr>
          </thead>

            <tbody>
              {detailBarang.map((item, index) => (
                <tr key={index}>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.NOMOR}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.NO_DO}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.JNS_GAJI}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>{item.KETERANGAN || '-'}</td>
                  <td style={{ border: '1px solid #ddd', padding: '8px' }}>
                    <input
                      type="text" readOnly
                      value={item.displayTotal}
                      onChange={(e) => handleQtyChange(index, e.target.value)}
                      onBlur={() => handleBlur(index)}
                      style={{
                        width: '90%',
                        padding: '5px',
                        borderRadius: '4px',
                        textAlign: 'right',
                        border: '1px solid #ccc',
                      }}
                    />
                  </td>
                  <td style={{ border: '1px solid #ddd', padding: '8px', textAlign: 'center' }}>
                    <button
                      onClick={() => handleHapusDetail(index)}
                      style={{ backgroundColor: '#f44336', color: 'white', border: 'none', borderRadius: '4px', padding: '5px 10px', cursor: 'pointer'
                      }}
                      disabled={status === '5' || status === '9'}
                    >
                      Hapus
                    </button>
                  </td>                  
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <p style={{ color: '#888' }}>Tidak ada detail.</p>
      )}

      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
        <button
          onClick={onCancel}
          style={{ backgroundColor: 'blue', color: 'white', padding: '10px 20px', border: 'none', borderRadius: '5px' }}
        >
          Batal
        </button>
        <button
          onClick={handleValidasi}
          disabled={status === '5' || status === '6' || status === '9'}
          style={{
            backgroundColor: status === '5' || status === '6' || status === '9' ? '#A5D6A7' : 'green',
            color: 'white',
            padding: '10px 20px',
            border: 'none',
            borderRadius: '5px'
          }}
        >
          Valid
        </button>
          
      </div>

    </>
)}

    </div>
  );
}

export default InputTs;
